export function initScrollState() {
	function updateScrolledState() {
		document.body.classList.toggle('has-scrolled', window.scrollY > 10);
	}

	window.addEventListener('load', updateScrolledState);
	window.addEventListener('scroll', updateScrolledState, { passive: true });
}
